import script from "./test-book.vue?vue&type=script&setup=true&lang=js"
export * from "./test-book.vue?vue&type=script&setup=true&lang=js"

import "./test-book.vue?vue&type=style&index=0&id=520e57bf&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-520e57bf"]])

export default __exports__